import { useFormContext } from "react-hook-form";
import styles from "./index.module.scss";
import { useProductFlags } from "src/hooks/recoil/useProductFlags";
import { useTranslation } from "react-i18next";

// 서비스 구독 상세 정보
const SubscriptionDetail = () => {
  const { watch } = useFormContext();
  const licenseCount = watch("licenseCount");
  const externalLicenseCount = watch("externalLicenseCount");
  const startDate = watch("startDate");
  const endDate = watch("endDate");
  const { isWrapsodyEco } = useProductFlags();
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.row}>
        <span className={styles.label}>
          {t("siteType.premium.detail.plan.user")}
        </span>
        <span className={styles.value}>{licenseCount}</span>
      </div>

      {isWrapsodyEco && (
        <div className={styles.row}>
          <span className={styles.label}>
            {t("siteType.premium.detail.plan.userExtenalInvite")}
          </span>
          <span className={styles.value}>{externalLicenseCount ?? 0}</span>
        </div>
      )}

      <div className={styles.periodSection}>
        <div className={styles.periodRow}>
          <span className={styles.periodLabel}>
            {t("siteType.premium.detail.plan.period")}
          </span>
          <div className={styles.periodValue}>
            <span className={styles.dateLabel}>
              {t("siteType.premium.detail.plan.startDate")}
            </span>
            |<span className={styles.periodDateValue}>{startDate}</span>
          </div>
        </div>
        <div className={styles.periodRow}>
          <span className={styles.periodLabel}></span>
          <div className={styles.periodValue}>
            <span className={styles.dateLabel}>
              {t("siteType.premium.detail.plan.endDate")}
            </span>
            |<span className={styles.periodDateValue}>{endDate}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionDetail;
